import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
import Linecharts from './../../components/Linecharts';
const $=window.$;

//const $=window.$;
// const win=window;

class MyPerformanceDemo extends Component {
	constructor(props) {
		super(props);

        this.state={
				};

	}
	

	getAssesStatus(type){
		this.props.switchPanel(type)
	}
	getTabs(){
		/*
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

							window.$('#ChildVerticalTab_1').easyResponsiveTabs({
			            type: 'vertical',
			            width: 'auto',
			            fit: true,
			            tabidentify: 'ver_1', // The tab groups identifier
			            //resp-tab-active
			           /* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
						} */
						/*
					});
					*/
					window.$('#performanceParentTab').easyResponsiveTabs({
						type: 'default', //Types: default, vertical, accordion           
						width: 'auto', //auto or any custom width
						fit: true,   // 100% fits in a container
						tabidentify: 'tab_identifier_parent', // The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
					});
					//child tab
					window.$('#performanceChildTab').easyResponsiveTabs({
						type: 'vertical', //Types: default, vertical, accordion           
						width: 'auto', //auto or any custom width
						fit: true,   // 100% fits in a container
						tabidentify: 'tab_identifier_child', // The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
					});
					
    }
	
	componentDidMount() {
		this.getTabs();
	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
			

		return (

		 <section id="contentsection" className="contentarea">
          

							<div className="inner-title-bg journey-tit-bg">
								<h1><span> <a > <img src={process.env.PUBLIC_URL+'/images/img-myperformance.jpg'} align="absmiddle" alt="" border="0" /> </a> </span> My Performance<br />
									<span className="subtitle">My cumulative performance in completed Learning Rooms.</span> </h1>
							</div>
							<div className="performance-body">       
		<div className="performanceParentTab" id="performanceParentTab">
			<ul className="resp-tabs-list tab_identifier_parent">
				<li>Performance Chart</li>
				<li>Percentile Report</li>				
			</ul> 
			<div className="resp-tabs-container tab_identifier_parent">
			
				<div>
					{/* <p> */}
						<div id="performanceChildTab" className="performanceChildTab">          
							<ul className="resp-tabs-list tab_identifier_child">
								<li>LR Room-wise</li>
								<li>LR Module-wise</li>
								<li>DLR Room-wise</li>
								<li>DLR Module-wise</li>
							</ul> 					
							<div className="resp-tabs-container tab_identifier_child">
								<div>
									<div className="img">
										<img src={"images/my-performance/subtab1.jpg"} alt={"images/my-performance/subtab1.jpg"} />
									</div>
								</div>
								<div>
									<div className="img" style={{margin: '30px 0 0'}}>
										<img src={"images/my-performance/subtab2.jpg"} alt={"images/my-performance/subtab1.jpg"} />
									</div>
									<div className="grySelectBox">
										<label>Select Module:</label>
										<select>
											<option>Select</option>
											<option>Item 1</option>
											<option>Item 2</option>
										</select>
									</div>
								</div>
								<div>
									<div className="img" style={{margin: '30px 0 0'}}>
										<img src={'images/my-performance/subtab3.jpg'} alt={"images/my-performance/subtab1.jpg"} />
									</div>
								</div>
								<div>
									<div className="img" style={{margin: '30px 0 0'}}>
										<img src={'images/my-performance/subtab4.jpg'} alt={"images/my-performance/subtab1.jpg"} />
									</div>
									<div className="grySelectBox">
										<label>Select Module:</label>
										<select>
											<option>Select</option>
											<option>Item 1</option>
											<option>Item 2</option>
										</select>
									</div>
								</div>
							</div>
						</div>    
					{/* </p> */}
				</div>
			
				<div>
					<div className="gryBoxText">
						<div className="left">
							<strong>K/A</strong> - Knowledge / Action Component   &nbsp;&nbsp; <strong>AS</strong> - Actual Score   &nbsp;&nbsp; <strong>MS</strong> - Maximum Score  &nbsp;&nbsp; <strong> %</strong> - Percentage Score &nbsp;&nbsp;<strong>G %ile</strong> - Group Percentile    &nbsp;&nbsp;<strong>U %ile </strong>- Universal Percentile
						</div>
						<div className="right">
							<a href="javascript:void(0);">Export Report</a>
						</div>
						<div className="clear"></div>
					</div>
					<div className="tblResponsive">
						<table>
						<tbody>
							<tr>
								<th>Rooms</th>
								<th>Module Name</th>
								<th>Component Name</th>
								<th>K/A</th>
								<th>AS/MS</th>
								<th>%</th>
								<th>G %ile</th>
								<th>U %ile</th>
							</tr>
							<tr>
								<td>AM24N</td>
								<td>Advertising <br/>Management</td>
								<td>Quiz 1- Advertising Management(13-24)</td>
								<td>KS</td>
								<td>2/16</td>
								<td>12.5</td>
								<td>0</td>
								<td>0</td>
							</tr>
							<tr>
								<td>HRM1-4</td>
								<td>HR Management</td>
								<td>Quiz 1 - HR Management Objectives and Challenges</td>
								<td>KS</td>
								<td>4/12</td>
								<td>33.33</td>
								<td>0</td>
								<td>4.32</td>
							</tr>
							<tr>
								<td>HRM1-4</td>
								<td>HR Management</td>
								<td>Quiz 2 - HR Management 1 -4 -Recap</td>
								<td>KS</td>
								<td>4/11</td>
								<td>36.36</td>
								<td>0</td>
								<td>5.71</td>
							</tr>
							<tr>
								<td>LR</td>
								<td>MBA Common</td>
								<td>Understanding Business </td>
								<td>KS</td>
								<td>34/54</td>
								<td>62.96</td>
								<td>29.41</td>
								<td>60.02</td>
							</tr>
							<tr>
								<td>LR</td>
								<td>MBA Common</td>
								<td>Useful Business Terms</td>
								<td>KS</td>
								<td>2/11</td>
								<td>18.18</td>
								<td>5.88</td>
								<td>2.04</td>
							</tr>
							<tr>
								<td>LR</td>
								<td>Principles of Management</td>
								<td>Assessment on Principles of Management Ch 1 to 4</td>
								<td>KS</td>
								<td>9/14</td>
								<td>64.29</td>
								<td>70.59</td>
								<td>73.14</td>
							</tr>
							<tr>
								<td>LR</td>
								<td>Managerial Communication</td>
								<td>Assessment on Managerial Communication Ch 1 to 4</td>
								<td>KS</td>
								<td>2/8</td>
								<td>25</td>
								<td>6.25</td>
								<td>5.18</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			
			</div>
			
		</div>
	</div>
							{/* <div className="myperformance">
								<section id="semana-scroll-inner" className="scroll">
									
									
									<section className="viewport">
										<section className="overview">
											<div className="inner-content">
												
												<div id="parentHorizontalTab">
													<ul className="resp-tabs-list hor_1 horizontaltabbg">
														<li>Performance Chart
															<div className="activearrow"><img src={process.env.PUBLIC_URL+'/images/activetab.png'} alt="" title="" border="0" /></div>
														</li>
														<li>Percentile Report
															<div className="activearrow"><img src={process.env.PUBLIC_URL+'/images/activetab.png'} alt="" title="" border="0" /></div>
														</li>
														
													</ul>
													
													<div className="resp-tabs-container hor_1 tapmargntop" id="responsivediv_show" >
														<div className="tab-content">
															<div id="ChildVerticalTab_1">
																<ul className="resp-tabs-list ver_1">
																	<li>LRs Room-wise<br />
																		<span></span></li>
																	<li>LRs Module-wise<br />
																		<span></span></li>
																	<li>DLRs Room-wise<br />
																		<span></span></li>
																	<li>DLRs Module-wise<br />
																		<span></span></li>
																</ul>
																<div className="resp-tabs-container ver_1">
																	<div className="verticaltab-content">
																		
																		<div className="performance-chart"> <img src={process.env.PUBLIC_URL+'/images/lrs_1.jpg'} /> </div>
																	</div>
																	
																	<div className="verticaltab-content">
																		
																		
																		<div className="performance-chart"> <img src={process.env.PUBLIC_URL+'/images/lrs_2.jpg'} /> </div>
																	</div>
																	
																	<div className="verticaltab-content">
																		
																		<div className="performance-chart"> <img src={process.env.PUBLIC_URL+'/images/lrs_3.jpg'} /> </div>
																	</div>
																	
																	<div className="verticaltab-content">
																		
																		<div className="performance-chart"> <img src={process.env.PUBLIC_URL+'/images/lrs_4.jpg'} /> </div>
																	</div>
																	
																</div>
															</div>
														</div>
														<div>
															<div className="tab-content table-cont4">
																<div className="abbrevation">
																	<ul>
																		<li><strong>K/A</strong> - Knowledge / Action Component</li>
																		<li><strong>AS</strong> - Actual Score </li>
																		<li><strong>MS</strong> - Maximum Score</li>
																		<li><strong>%</strong> - Percentage Score</li>
																		<li><strong>G %ile</strong> - Group Percentile</li>
																		<li><strong>U %ile</strong> - Universal Percentile</li>
																	</ul>
																	<span className="rgt-fl">Export report</span>
																</div>
																
																<table className="myjourney-table w-bg tablesorter tablesorter-default" width="100%" cellspacing="0" cellpadding="0" border="0">
																	<colgroup>
																	</colgroup>
																	<thead>
																		<tr className="tablesorter-headerRow">
																			<th data-column="0" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">Rooms<img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="" /></div></th>
																			<th data-column="1" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">Module Name <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="" /></div></th>
																			<th data-column="2" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">Component Name</div></th>
																			<th data-column="3" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">K/A <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="component - Indicates components that test knowledge / component - Indicates components that are action or practice based" /></div></th>
																			<th data-column="4" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">AS/MS <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="Indicates the actual scores made by the learner / Indicates the maximum score out of which the learner's performance was measured" /></div></th>
																			<th data-column="5" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">% <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="Indicates the percentage score made by the learner so far (AS divided by MS" /></div></th>
																			<th data-column="6" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">G %ile <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="Indicates the learner's position among the current group of learners" /></div></th>
																			<th data-column="7" className="tablesorter-header" tabindex="0" unselectable="on" style={{mozuserselect: 'none'}}><div className="tablesorter-header-inner">U %ile <img src={process.env.PUBLIC_URL+'/images/sort-arrow.png'} alt="" title="Indicates the learner's universal position among all the group of learners as on date" /></div></th>
																		</tr>
																	</thead>
																	<tbody>
																		<tr className="oddbg">
																			<td>AM24N</td>
																			<td>Advertising Management</td>
																			<td>Quiz 1 - Advertising Management (13-24)</td>
																			<td>KS</td>
																			<td>2/16</td>
																			<td>12.5</td>
																			<td>0</td>
																			<td>0</td>
																		</tr>
																		<tr className="evenbg">
																			<td>HRM1-4</td>
																			<td>HR Management</td>
																			<td>Quiz 1 - HR Management Objectives and Challenges</td>
																			<td>KS</td>
																			<td>4/12</td>
																			<td>33.33</td>
																			<td>0</td>
																			<td>4.32</td>
																		</tr>
																		<tr className="oddbg">
																			<td>HRM1-4</td>
																			<td>HR Management</td>
																			<td>Quiz 2 - HR Management 1 - 4 - REcap</td>
																			<td>KS</td>
																			<td>4/11</td>
																			<td>62.96</td>
																			<td>29.41</td>
																			<td>60.02</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>MBA Common</td>
																			<td>Useful Business Terms</td>
																			<td>KS</td>
																			<td>2/11</td>
																			<td>18/18</td>
																			<td>5.88</td>
																			<td>2.04</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>Principles of Management</td>
																			<td>Assessment on Principles of Management Ch 1 to 4</td>
																			<td>KS</td>
																			<td>9/14</td>
																			<td>64.29</td>
																			<td>70.59</td>
																			<td>73.14</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR </td>
																			<td>Mangerial Communication</td>
																			<td>Assessment on Managerial Communication Ch to 4</td>
																			<td>KS</td>
																			<td>2/8</td>
																			<td>25</td>
																			<td>6.25</td>
																			<td>5.18</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd7 - ENOP performance(Yes)</td>
																			<td>KS</td>
																			<td>0/0</td>
																			<td>0</td>
																			<td>25</td>
																			<td>50</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd8  - ENOV performance(Yes)</td>
																			<td>KS</td>
																			<td>3/3</td>
																			<td>100</td>
																			<td>25</td>
																			<td>50</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd8  - ENOV performance(Yes)</td>
																			<td>KS</td>
																			<td>3/3</td>
																			<td>100</td>
																			<td>25</td>
																			<td>50</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>testadd1 - EVOV performance(Yes)</td>
																			<td>KS</td>
																			<td> 87/90 </td>
																			<td>96.67</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>testadd1 - EVOV performance(Yes)</td>
																			<td>KS</td>
																			<td>2/95</td>
																			<td>2.11</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd7 - ENOP performance(Yes)</td>
																			<td>KS</td>
																			<td>0/0</td>
																			<td>0</td>
																			<td>25</td>
																			<td>50</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>testadd1 - EVOV performance(Yes)</td>
																			<td>KS</td>
																			<td>86/90</td>
																			<td>95.56</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>goback(yes)  &amp;&amp; Time variale- EVOP performance(Yes)</td>
																			<td>KS</td>
																			<td>0/4</td>
																			<td>0</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Digital - 3</td>
																			<td>AS (O), AS (E)</td>
																			<td>6/10</td>
																			<td>60</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd - EPOP performance(Yes)</td>
																			<td>KS</td>
																			<td>11/20</td>
																			<td>55</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>xrecap-vls-betcomp</td>
																			<td>KS</td>
																			<td>1/4</td>
																			<td>25</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>xrecap-vls-betcomp</td>
																			<td>KS</td>
																			<td>1/4</td>
																			<td>25</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>xrecap-vls-betcomp</td>
																			<td>KS</td>
																			<td>1/4</td>
																			<td>25</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>xrecap-vls-betcomp</td>
																			<td>KS</td>
																			<td>1/4</td>
																			<td>25</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Testadd - EPOP performance(Yes)</td>
																			<td>KS</td>
																			<td>8/24</td>
																			<td>33.33</td>
																			<td>83.33</td>
																			<td>85.71</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>Java -EPOP</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>test reverse type</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>LR</td>
																			<td>QA Check 2</td>
																			<td>test reverse type</td>
																			<td>AS (O), AS (E)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="oddbg">
																			<td>QA1</td>
																			<td>QA Check 2</td>
																			<td>PHP-ENOP</td>
																			<td>AS (O)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																		<tr className="evenbg">
																			<td>QA1</td>
																			<td>QA Check 2</td>
																			<td>C++ - EVOP</td>
																			<td>AS (O)</td>
																			<td>YTA</td>
																			<td>-</td>
																			<td>-</td>
																			<td>-</td>
																		</tr>
																	</tbody>
																</table>
																
															</div>
														</div>
													</div>
													
												</div>
											</div>
											
										</section>
									</section>
								</section>
								
							</div> */}

    </section>
			);

		}
}

export default MyPerformanceDemo;



// WEBPACK FOOTER //
// ./src/learning_records/my_performance/MyPerformanceDemo.js